module.exports = __webpack_public_path__ + "img/platform-activities-7-days-in-row.affc5a05.png";